import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { THEMES, useTheme } from "@/lib/theme";

export function SettingsPage() {
  const [theme, setTheme] = useTheme();

  return (
    <div className="max-w-3xl space-y-6">
      <h2 className="text-lg font-semibold">Innstillinger</h2>

      <Card>
        <CardHeader>
          <CardTitle>Utseende</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div role="group" aria-label="Utseende" className="flex flex-wrap gap-2">
            {THEMES.map((t) => (
              <Button
                key={t.id}
                aria-pressed={theme === t.id}
                size="sm"
                variant={theme === t.id ? "default" : "outline"}
                onClick={() => setTheme(t.id)}
              >
                {t.label}
              </Button>
            ))}
          </div>
          <p className="text-sm text-admin-text-secondary">
            Onyxia er slik backoffice ser ut i dag. Rigg er den varme, dempede paletten fra Rigg, i lys og
            mørk utgave. Auto følger maskinen og bytter med den; lys og mørk holder seg uansett.
          </p>
          <p className="text-xs text-admin-text-subtle">
            Valget lagres i denne nettleseren. En annen nettleser, eller denne tømt, er tilbake på Onyxia.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
